import { IUserPreferencesRepository } from '../../domain/repositories/IUserPreferencesRepository';
import { UserPreferences } from '../../domain/value-objects/UserPreferences';
import { supabase } from '@shared/config/supabase';

/**
 * Supabase User Preferences Repository
 * Implements IUserPreferencesRepository using Supabase
 */
export class SupabaseUserPreferencesRepository implements IUserPreferencesRepository {
  /**
   * Get preferences for a user
   */
  async getPreferences(userId: string): Promise<UserPreferences> {
    const { data, error } = await supabase
      .from('users')
      .select('preferences')
      .eq('id', userId)
      .single();

    if (error) {
      console.error('Failed to fetch user preferences:', error);
      // Return default preferences on error
      return UserPreferences.create();
    }

    return UserPreferences.fromJSON(data?.preferences);
  }

  /**
   * Update preferences for a user
   */
  async updatePreferences(_userId: string, preferences: UserPreferences): Promise<UserPreferences> {
    // Use RPC function for secure, server-side update
    const { data, error } = await supabase
      .rpc('update_user_preferences', {
        new_preferences: preferences.toJSON()
      });

    if (error) {
      throw new Error(`Failed to update preferences: ${error.message}`);
    }

    return UserPreferences.fromJSON(data);
  }
}
